<template>
	<div class="template-messages-list">

		<div 
			v-if="$store.state.auth.role === 'admin'"
			class="flex justify-end">
			<vs-button
				color="success"
				type="filled"
				@click="$router.push('/partners/create')"
			>{{ $t('add') }}</vs-button>
		</div>

		<vx-card class="my-8">
			<div class="tab-text ">
				<vs-table max-items="10" pagination :data="works">
					<template slot="thead">
						<vs-th v-for="fil in field" :style="'width:' +fil.width" :class="{'justify-center': fil.align && fil.align === 'center'}">
							{{ fil.title }}
						</vs-th>
					</template>

					<template slot-scope="{ data }">
						<vs-tr :key="indextr"  v-for="(tr, indextr) in data">
							<template v-for="fil in field">
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-if="fil.field === 'emailPartner'" >
										{{ tr.emailPartner }}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-if="fil.field === 'countWebsitePartner'" >
										{{ tr.countWebsitePartner }}
								</vs-td>

								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'actions'">
									<div class="flex justify-center">
										<vs-button
											size="small"
											color="#626262"
											type="flat"
											icon-pack="feather"
											@click="loginAs(tr)"
											icon="edit"
										>
											<feather-icon icon="LogInIcon"></feather-icon>
										</vs-button>
										<vs-button
											size="small"
											color="#626262"
											type="flat"
											icon-pack="feather"
											@click="$router.push(`/partners/edit/${tr.id}`)"
											icon="edit"
										>
											<feather-icon icon="EditIcon"></feather-icon>
										</vs-button>
										<vs-button
											v-if="$store.state.auth.role === 'admin'"
											size="small"
											color="#626262"
											type="flat"
											icon-pack="feather"
											@click="showDeleteDialog(tr.id, tr.emailPartner)"
											icon="edit"
										>
											<feather-icon icon="Trash2Icon"></feather-icon>
										</vs-button>
									</div>
								</vs-td>
							</template>

						</vs-tr>
					</template>
				</vs-table>
			</div>
		</vx-card>
	</div>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import notifier from '../../mixins/notifier';

export default {
	name: "listPartners",
	mixins: [databaseManager, notifier],
	data() {
		return {
			emailPartner: '',
			message: '',

			activePrompt: false,
			activePromptEdit: false,
			popupActiv: false,
			subjects: [],
			works: [],
			editModel: {}
		};
	},
    components: {

	},
	methods: {
		short: (str, maxlen) => str.length <= maxlen ? str : str.slice(0, maxlen) + ' ...',
		async loginAs(partner) {
			try {
				const url = `/admin/partners/get-token?email=${partner.emailPartner}`;
				const res = (await this.$http.get(url)).data.data;
				window.open(`/token/${res.role}/${res.token}`);
			} catch(e) {
				this.notifyError(e.message);
			}
		},
		showDeleteDialog(id, name) {
			this.$vs.dialog({
				color: "danger",
				title: this.$t('confirmDeletion'),
				acceptText: this.$t('delete'),
				cancelText: this.$t('cancel'),
				text: `${this.$t('doYouWantToDelete')} "${name}"`,
				accept: () => this.removePartner(id),
			});
		},
		async removePartner(id){
			try {
				await this.dbDeletePartner(id);

				const index = this.works.findIndex(item => item.id === id);

				if(index !== -1) this.works.splice(index, 1);

				this.notifySuccess(this.$t('deletedSuccessfully'));

			} catch (e) {
				this.notifyError(e.message);
			}
		},
		deepFind(obj, path) {
			if (!path) return "";
			let paths = path.split("."),
				current = obj,
				i;

			for (i = 0; i < paths.length; ++i) {
				if (current[paths[i]] === undefined) {
					return undefined;
				} else {
					current = current[paths[i]];
				}
			}
			return current;
		},
		async getPartnersList() {
			try {
				this.works = await this.dbGetPartners();
			} catch (e) {
				this.$vs.notify({
					title: "Error",
					text: e.message,
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "danger",
				});
			}
		},
	},
	created() {
		this.field = [
			{
				field: "emailPartner",
				title: this.$t('emailPartner'),
				width: '60%',
			},
			{
				field: "countWebsitePartner",
				title: this.$t('countWebsitePartner'),
				width: '30%',
			},
			{
				field: "actions",
				title: this.$t("actions"),
				align: 'center',
				width: '10%',
			},
		];
	},
	async mounted() {
		this.getPartnersList();
	},
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/vuexy/variables.scss";
@import "../../assets/scss/vuexy/functions.scss";
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}
.inputInTable {
	border: 0;
	resize: none;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}

.buttons {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	@media screen and (max-width: 375px) {
		button {
			margin: 5px 0;
		}
	}
}
.justify-center .vs-table-text{
	justify-content: center;
}
.vs-checkbox-default{
	flex-shrink: 0;
}
.vs-tabs--content {
	padding: 0;
	margin-top: 10px;
}

.vs-con-table .vs-con-tbody {
	border: 0;
	background-color: transparent;
}
.con-exemple-prompt {
	.append-text {
		height: 2.7rem;
	}
	.vs-button {
		border-left: 0;
	}
	.vx-input-group-append {
		align-items: flex-end;
	}
	.vs-input {
		width: 100%;
		textarea {
			resize: none;
		}
	}
}

.vs-table {
	margin-top: 10px;

	tr {
		border-top: 1px solid #cfcfcf;

		&:last-child {
			border-bottom: 1px solid #cfcfcf;
		}
	}
}
.con-vs-tabs .con-slot-tabs{
	overflow: visible;
}
.task {
	background-color: #3ac47d;
	border-radius: 10px;
	padding: 4px 10px;
	color: white;
}
.counter {
	display: inline-block;
	padding: 5px;
	border-radius: 100%;
	font-weight: 600;
	width: 20px;
	height: 20px;
	font-size: 0.7rem;
	border: 1px solid #cfcfcf;
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 1;

	&.warn {
		background-color: #f0ad4e;
		color: white;
		border-color: #f0ad4e;
	}
}
.viewTask {
	.vs-popup--title h3 {
		color: $primary;
	}
	.vs-popup--content {
		padding: 0;
	}
	table {
		width: 100%;
		td {
			padding-bottom: 4px;
		}
	}
	.body {
		padding: 1rem;
		table {
			margin-left: -2px;
		}
		p {
			padding-top: 10px;
			font-size: rem(14px);
		}
	}
	.footer {
		border-top: 1px solid rgba(0, 0, 0, 0.05);
		padding: 0.5rem 1rem;
		display: flex;
		justify-content: flex-end;
		button {
			margin-left: 10px;
		}
	}
}
.filter {
	border-bottom: 1px solid #e5e5e5;
	padding-bottom: 1rem;
	padding-top: 0.5rem;
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	.date {
		display: flex;
		align-items: center;
	}
	.vx-input-group .vx-input-group-default .vs-input {
		width: 150px;
	}
	.vx-input-group {
		margin-right: 20px;
	}
	.search .vs-icon {
		height: 100%;
		width: 35px;
		background: $primary;
		position: absolute;
		top: 0;
		right: 0;
		color: white !important;
		display: flex;
		align-items: center;
		justify-content: center;
		border-top-right-radius: 4px;
		border-bottom-right-radius: 4px;
		font-size: 22px;
	}
	.search .vs-con-input-label {
		width: 270px;
	}
}
.template-messages-list {
	.buttons {
		justify-content: flex-end;
	}
	.button-task {
		border-radius: 22px;
		padding: 0.25rem 0.7rem !important;
	}
}
.con-vs-dialog .vs-dialog  {
	width: 100% !important;
	max-width: 800px !important;
}
.set-ticket-done__controls {
	text-align: right;
}
.tox {
	z-index: 999992 !important;
}
.tox-tiered-menu{
	z-index: 999993 !important;
}
.tox-menu {
	z-index: 999994 !important;
}

</style>
